import React, { Component } from 'react'
import { withRouter } from 'react-router-dom';
import backgroundImage from '../assets/images/menu/bg.png'
import menuBackground from '../assets/images/menu/menu-bg.png';
import gameBtn from '../assets/images/menu/game-btn.png'
import knowAircraftBtn from '../assets/images/menu/know-aircraft-btn.png';
import knowJobBtn from '../assets/images/menu/know-job-btn.png';

class Menu extends Component {

    btnSound = './sounds/menu.mp3';

    constructor(props) {
        super(props);
    }
    
    goToGameDescPage() {
        this.playBtnSound();
        this.props.history.push({
            pathname: './game-desc',
            state: {}
        });
    };

    goToLearnAircraftPage() {
        this.playBtnSound();
        this.props.history.push({
            pathname: './aircraft-intro',
            state: {}
        });
    }

    gotToLearnAirJobPage() {
        this.playBtnSound();
        this.props.history.push({
            pathname: './aircraft-fix',
            state: {}
        });
    }

    playBtnSound() {
        let btnAudio = new Audio(this.btnSound);
        btnAudio.play();
    }

    render() {
        return (
            <div className='page-root-div'>
                <img alt='' src={backgroundImage} style={{ width: '100%', height: '100%', overflow: 'hidden', objectFit: 'cover', position: 'absolute' }}/>
                {/* <img alt='' src={menuBackground} style={{ width: '78%', position: 'absolute', left: '2.5%', top: '13%' }}></img> */}
                <img className='press-btn' alt='' src={gameBtn} style={{ height: '11.3%', top: '54%', left: '40%', position: 'absolute', background: 'transparent' }} onClick={this.goToGameDescPage.bind(this)}/>
                <img className='press-btn' alt='' src={knowAircraftBtn} style={{ height: '11.3%', top: '41.5%', left: '40%', position: 'absolute', background: 'transparent' }} onClick={this.goToLearnAircraftPage.bind(this)}/>
                <img className='press-btn' alt='' src={knowJobBtn} style={{ height: '11.3%', top: '29%', left: '40%', position: 'absolute', background: 'transparent' }} onClick={this.gotToLearnAirJobPage.bind(this)}/>
            </div>
        )
    }
}

export default withRouter(Menu);
